import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_lp_changes} from "../_signals/s_char";
import {ICharLPChanges} from "../_interfaces/ICharLPChanges";

export const LPChangesGet = (cid: string) => {
    fetch(apiAddress + "/char/lpchanges/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('LPChanges get', data);
                if (data.hasOwnProperty('result')) {
                    s_char_lp_changes.value = (data.result as ICharLPChanges[])
                }
            }
        )
}

export const LPChangesCreate = (lpchanges: ICharLPChanges) => {
    fetch(apiAddress + "/char/lpchanges/", createOptions('CREATE', lpchanges))
        .then((res) => res.json())
        .then((data) => console.log('LPChanges create', data))
        .catch((reason => console.log('LPChanges create catch', reason)))
}

export const LPChangesUpdate = (lpchanges: ICharLPChanges) => {
    fetch(apiAddress + "/char/lpchanges/", createOptions('UPDATE', lpchanges))
        .then((res) => res.json())
        .then((data) => console.log('LPChanges update', data))
        .catch((reason => console.log('LPChanges create catch', reason)))
}